import type { GatewaysDataSlice } from './gateways.type'

export const gatewaysInitialState: GatewaysDataSlice = {
  gateways: [],
  loading: false,
  error: null,
  lastFetchedProjectId: null,
  projectHasGateways: null,
}
